import { AxisSwitcher, Button, H2, Image, PortableText, TypeWrapper } from '@ahmdigital/ui';

import styles from './styles.module.sass';
import WrappedSection from '../wrapped-section';

type CalloutSectionProps = {
  cta?: {
    onClick?: (...args: unknown[]) => unknown;
    title?: string;
    to?: string;
  };
  image?: {
    alt: string;
    src: string;
  };
  summary?: string | unknown[];
  title: string | unknown[];
  withBorder?: boolean;
};

const CalloutSection = ({ cta, image, summary, title, withBorder = false }: CalloutSectionProps) => (
  <WrappedSection withBorder={withBorder}>
    <AxisSwitcher reverseColumnPresentationOrder limit={2} threshold="48rem">
      {image && (
        <TypeWrapper variant="center">
          <Image src={image.src} alt={image.alt} className={styles.image} />
        </TypeWrapper>
      )}
      <div className={styles.content}>
        {title && (
          <H2 looksLike="h3">
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
            <PortableText source={title} />
          </H2>
        )}
        {summary && (
          <div className={styles.paragraph}>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
            <PortableText source={summary} />
          </div>
        )}
        {cta && cta.title && (cta.onClick || cta.to) && (
          <Button to={cta.to} onClick={cta.onClick}>
            {cta.title}
          </Button>
        )}
      </div>
    </AxisSwitcher>
  </WrappedSection>
);

export default CalloutSection;
